export default [
  {
    name: 'Name',
    selector: (row) => row.attributes.member,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Work Email',
    selector: (row) => row.attributes.work_email,
    sortable: true,
    searchable: true,
  },
  {
    name: 'Team',
    selector: (row) => row.attributes.team,
    sortable: true,
  },
  {
    name: 'Program',
    selector: (row) => row.attributes.program.title,
    sortable: true,
  },
  {
    name: 'Completed',
    selector: (row) => row.attributes.program.last_session_completed_date,
    sortable: true,
  },
  {
    name: 'Claim Date',
    selector: (row) => row.attributes.date,
    sortable: true,
  },
];
